import { errorMessage, updateLogoRoute } from '@features/profile';
import axiosInstance from '@server/axiosInstance';
import { profileKey } from '@staffedupusa/shared-components';
import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

type UseUpdateProfileImageProps = {
  setAlertText?: Dispatch<SetStateAction<string>>;
};

export const useUpdateProfileImage = ({
  setAlertText = () => {},
}: UseUpdateProfileImageProps) => {
  const client = useQueryClient();

  const { mutate: updateProfileImage, isLoading: isUpdatingProfileImage } =
    useMutation({
      mutationFn: (variables: { logo?: string; cover_image?: string }) =>
        axiosInstance.post(updateLogoRoute, variables).then((res) => res.data),
      onSuccess: (data) => {
        if (data.status !== 200) {
          setAlertText(data.message);
        } else {
          setAlertText('');
          client.invalidateQueries([profileKey]);
        }
      },
      onError: () => {
        setAlertText(errorMessage);
      },
    });

  return {
    updateProfileImage,
    isUpdatingProfileImage,
  };
};
